import React from 'react';
import { Modal, makeStyles, Theme, createStyles, Backdrop, Fade } from '@material-ui/core';
import { PrizeForm } from './PrizeForm';
import { Prize } from './types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    form: {
      backgroundColor: theme.palette.background.paper,
      border: '0px',
      borderRadius: '2px',
      boxShadow: theme.shadows[5],
      outline: 'none',
    },
  })
);

type Props = {
  open: boolean;
  seasonId: string;
  prize?: Prize | null;
  withCode: boolean;
  onClose: () => void;
};

export const PrizeModal = ({ open, seasonId, prize, withCode, onClose }: Props) => {
  const classes = useStyles();

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={classes.modal}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <div className={classes.form}>
          <PrizeForm seasonId={seasonId} prize={prize} withCode={withCode} onClose={onClose} />
        </div>
      </Fade>
    </Modal>
  );
};
